/* Aura P2 — the REAL network deps for the suggest + write flow. Kept separate from
 * useSuggestWriteVoice so tests inject fakes (options seam). */
import { listConnections } from '@/data/connections';
import { proposeOneArticle, suggestArticles, writeArticle } from '@/data/auraArticles';
import { batchSiteOptions } from './batchPublishModel.ts';
import type { SuggestWriteDeps } from './useSuggestWriteVoice.ts';

export const defaultSuggestWriteDeps: SuggestWriteDeps = {
  async listSites() {
    return batchSiteOptions(await listConnections());
  },
  async suggest(targetId, channel, viewedProjectId) {
    return suggestArticles(targetId, channel, viewedProjectId);
  },
  async proposeOne(targetId, keyword, channel, viewedProjectId) {
    return proposeOneArticle(targetId, keyword, channel, viewedProjectId);
  },
  async write(token, targetId, index, keyword) {
    return writeArticle(token, targetId, index, keyword);
  },
};
